import Filters from "../components/Filters/Filters";
import InstantSearchWrapper from "../components/layout/Search/InstantSearchWrapper";
import MainHits from "../components/Hits/MainHits";
import Search from "../components/Search/Search";
import Pagination from "../components/Pagination/Pagination";
import CategoryFilters from "../components/Filters/CategoryFilters/CategoryFilters";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getProducts } from "../services/algoliaProductService";
import { AlgoliaFinishHit } from "../types/AlgoliaTypes";

interface MaterialDrawerProps {
    indexName: string;
}
export default function MaterialDrawer({indexName}: MaterialDrawerProps) {

    const [searchParams] = useSearchParams();
    const [selectedCategory, setSelectedCategory] = useState("All");
    const [selectedCount, setSelectedCount] = useState(0);
    const [productToFilter, setProductToFilter] = useState("");
    const [productData, setProductData] = useState<AlgoliaFinishHit[]>([]);
    
    useEffect(() => {

        const retrieveDataAttribute = () => {
            
            const dataSearch = document.getElementById("fl-root")?.getAttribute("data-search");
            
            if(dataSearch) {
                setProductToFilter(dataSearch)
            }
            
        }

        retrieveDataAttribute();
    }, [])

    useEffect(() => {
        const getProductsFromAlgolia = async () => {
            if(productToFilter && productToFilter.length > 0) {
                const data = await getProducts(productToFilter)
                
                setProductData(data);
            }
        }

        getProductsFromAlgolia();

    }, [productToFilter])

    return (
        <div className="fl-container__flex">
            <InstantSearchWrapper indexName={indexName} productsToFilter={productData && productData.length > 0 ? productData.map(({ objectID }) => objectID) : undefined}>
                <div className={"fl-container__flex fl-container__flex--gap"} style={{ paddingTop: "20px", backgroundColor: "white" }}>
                    <Search />
                    <CategoryFilters setSelectedCategory={(category) => setSelectedCategory(category)} setSelectedCount={(count) => setSelectedCount(count)}/>            
                </div>
                <div className={"fl-container__content fl-container__flex fl-container__flex--gap"} style={{ paddingTop: "20px" }}>
                    <Filters />
                    <div className={"search-page__number-results"}>{selectedCount.toString()} {selectedCategory}</div>
                    <MainHits useSteelcaseLink={true} />
                    <Pagination />
                </div>
            </InstantSearchWrapper>
        </div>
    )
}